module.exports = " <div> <div style=\"text-align:center;padding:10px 0 10px 10px\" class=clearfix> <input type=text id=search_{{treeId}} value=\"\" class=empty ng-class=\"{'col-xs-7':showCheckall}\" placeholder=请输入关键字 autocomplete=off /> <label for=checkAll_{{treeId}} ng-show=config.isCheckall> <input id=checkAll_{{treeId}} type=checkbox ng-change=checkAllChange() ng-model=checkAll> 全选 </label> </div> <div id={{treeId}} class=ztree style=height:200px;overflow:scroll> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/yTree/template.html
// module id = PQUL
// module chunks = 0